import { CSSProperties, ReactNode, useEffect } from "react"
import { setupSlider } from "../components/slider"

interface Props {
    min: number
    max: number
    value: number
    setValue: (value: number) => void
    thumbContent?: ReactNode
    trackStyle?: CSSProperties
}

const defaultTrackStyle: CSSProperties = {
    userSelect: "none",
    width: "100%",
    border: "none"
}

const thumbStyle: CSSProperties = {
    position: "absolute",
    marginLeft: "-10px",
    border: "none",
    height: "16px",
    width: "16px",
    borderRadius: "50%",
    cursor: "pointer"
}

export function Slider({ min, max, value, setValue, thumbContent, trackStyle }: Props) {

    const wrapper = React.useRef<HTMLDivElement>()
    const thumb = React.useRef<HTMLDivElement>()

    const [state, setState] = React.useState({
        left: undefined as number,
        value: undefined as number
    })

    useEffect(() => {

        if (state.value != value) {
            setState(s => ({
                ...s,
                left: 100 * (value - min) / (max - min),
                value
            }))
        }

    })

    useEffect(() => {

        return setupSlider(thumb.current, wrapper.current, pct => {

            setState(s => ({ ...s, left: (100 * pct) }))

            setValue(min + (pct * (max - min)))

        })

    }, [min, max, setValue])

    return <div className="omnia-slider" ref={wrapper} style={{ position: "relative", width: "100%", touchAction: "manipulation" }}>

        <div style={{ ...defaultTrackStyle, ...trackStyle }} className="track">
        </div>

        <div ref={thumb} className="thumb" style={{ ...thumbStyle, left: state.left + "%" }}>
            {thumbContent}
        </div>

    </div>

}
